import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

let activeInstance = null;

const initPsw = (source, i, options = {}) => {
  const pswpElement = document.querySelector('#photoswipe');
  if (!pswpElement) return undefined

  if (activeInstance) {
    activeInstance.close();
  }

  const photoSwipe = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, source, {
    index: i,
    closeOnScroll: false,
    shareEl: false,
  });

  activeInstance = photoSwipe;
  photoSwipe.listen('destroy', () => {
    if (activeInstance === photoSwipe) activeInstance = null;
  });

  if (options.onOpen) {
    photoSwipe.listen('bindEvents', () => {
      options.onOpen();
    });
  }
  if (options.onClose) {
    photoSwipe.listen('unbindEvents', () => {
      options.onClose();
    });
  }
  photoSwipe.init();

  return photoSwipe;
};

export default initPsw;
